import { createInertiaApp, Head } from '@inertiajs/vue3'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { createPinia } from 'pinia'
import { createApp, h } from 'vue'
import { ZiggyVue } from '../../vendor/tightenco/ziggy'
import { createGtm } from '@gtm-support/vue-gtm'
import { createHead } from '@unhead/vue'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import * as Sentry from '@sentry/vue'
import DefaultLayout from './Layouts/DefaultLayout.vue'

import './bootstrap'
import '../css/app.css'

const appName = import.meta.env.VITE_APP_NAME || 'Laravel'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const GTMEnabled = import.meta.env.VITE_GTM_ENABLED === 'true'
const GTMDebug = import.meta.env.VITE_GTM_DEBUG === 'true'
const GTMKey = import.meta.env.VITE_GTM_KEY || ''

const gtmParams = {
	enabled: GTMEnabled,
	id: GTMKey,
	debug: GTMDebug,
	defer: false,
	compatibility: false,
}

createInertiaApp({
	title: (title) => (title ? `${title} - ${appName}` : `${appName}`),
	resolve: async (name) => {
		const page = await resolvePageComponent(
			`./Pages/${name}.vue`,
			import.meta.glob('./Pages/**/*.vue')
		)

		page.default.layout = page.default.layout || DefaultLayout

		return page
	},
	setup({ el, App, props, plugin }) {
		const app = createApp({ render: () => h(App, props) })
		const unHead = createHead()

		Sentry.init({
			app,
			dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
			environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
			tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
			replaysSessionSampleRate: import.meta.env
				.VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE,
			replaysOnErrorSampleRate: import.meta.env
				.VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE,
			integrations: [
				Sentry.browserTracingIntegration(),
				Sentry.replayIntegration(),
			],
		})

		app.use(plugin)
			.use(ZiggyVue)
			.use(pinia)
			.use(createGtm(gtmParams))
			.use(VueDOMPurifyHTML)
			.component('Head', Head)
			.use(unHead)
			.mount(el)

		return app
	},
	progress: {
		color: 'rgb(163 247 181)',
	},
})
